export enum FilterCode {
  PriceLte100 = 'priceLte100',
  PriceGte200 = 'priceGte200',
  RateEt1 = 'rateEt1',
  RateEt3 = 'rateEt3',
  RateEt5 = 'rateEt5',
}
